<template>
  <RouterView/>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'

useHead({
  title: 'Bistroo - Maakt iedere online bestelling makkelijk',
  meta: [
    {name: 'description', content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.'},
    {name: 'viewport', content: 'width=device-width, initial-scale=1.0'},
    {name: 'charset', content: 'UTF-8'},
    {name: 'canonical', content: 'https://www.bistroo.nl'},

    {property: 'og:title', content: 'Maakt iedere online bestelling makkelijk'},
    {property: 'og:description', content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.'},
    {property: 'og:image', content: 'https://www.bistroo.nl/images/business-portal/bistroo-zakelijk-og-image.jpg'},
    {property: 'og:type', content: 'website'},
    {property: 'og:url', content: 'https://www.bistroo.nl'},
    {property: 'og:site_name', content: 'Bistroo'},

    {name: 'twitter:title', content: 'Maakt iedere online bestelling makkelijk'},
    {name: 'twitter:description', content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.'},
  ],
  link: [
    {rel: 'icon', href: '/favicon.ico'},
  ],
  script: [
    ...(import.meta.env.VITE_GTM_ID ? [{
      src: `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GTM_ID}`,
      async: true
    }, {
      innerHTML: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${import.meta.env.VITE_GTM_ID}');
        `
    }] : []),
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Maakt iedere online bestelling makkelijk",
        "description": "Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo."
      }`
    }
  ]
})
</script>

<style scoped>

</style>